import { serverData } from "@aceroll/core";
import { StateMachine } from "@aceroll/core/core/stateMachine/StateMachine";

StateMachine.prototype.getNextStateName = function (fromStateName) {
    let nextStateName = "idle";
    let hasBonus;
    let nextResponses;
    let hasMaxWin;

    switch (fromStateName) {
        case 'spin.start':
            console.log('spin start current response: ', serverData.currentResponse);
            nextStateName = serverData.isRoundValid() ? 'round.start' : 'round.fail';
            break;

        case "result":
            // hasBonus = serverData.hasBonus();
            // nextResponses = serverData.nextResponses.length > 0;
            // hasMaxWin = serverData.nextResponses.length === 1 && (serverData.nextResponses[0].etn === 'max_win_reached');
            // if (!nextResponses) {
            //     nextStateName = "round.completed";
            // }
            // if (hasBonus && serverData.currentResponse.bonusFeatureWon[0].name.includes("respin")) {
            //     nextStateName = "respin";
            // }
            // if (serverData.currentResponse.name.includes("respin") && nextResponses) {
            //     nextStateName = "respin";
            // }
            // if (hasMaxWin) {
            //     nextStateName = "round.completed";
            // }
            // if (hasBonus && serverData.currentResponse.bonusFeatureWon[0].name.includes("bonus")) {
            //     nextStateName = "feature.enter";
            // }

            // Current response already shifted.
            nextStateName = 'round.completed';
            switch (serverData.currentResponse.name) {
                case 'feature_enter':
                    nextStateName = 'feature.enter';
                    break;
                case 'respin':
                    // case 'bonus1_respin':
                    // case 'bonus2_respin':
                    nextStateName = 'respin';
                    break;
                case 'max_win_reached':
                    nextStateName = 'max.win';
                    break;
            }

            break;
        case "feature.spin.result":
            hasBonus = serverData.hasBonus();
            nextResponses = serverData.nextResponses.length > 0;
            hasMaxWin = serverData.nextResponses.length === 2 && (serverData.nextResponses[0].etn === 'max_win_reached');
            nextStateName = "feature.round.completed";

            // if (!nextResponses) {
            //     nextStateName = "feature.round.completed";
            // }
            // if (hasBonus && serverData.currentResponse.bonusFeatureWon[0].name.includes("respin")) {
            //     nextStateName = "respin";
            // }
            // if (serverData.currentResponse.name.includes("respin") && serverData.featureCount['respin'] > 0) {
            //     nextStateName = "respin";
            // }
            // if (serverData.currentResponse.name.includes("respin") && serverData.featureCount['respin'] <= 0) {
            //     nextStateName = "feature.round.completed";
            // }
            // if (hasMaxWin) {
            //     nextStateName = "feature.round.completed";
            // }
            // if (hasBonus && serverData.currentResponse.bonusFeatureWon[0].name.includes("bonus")) {
            //     nextStateName = "feature.enter";
            // }

            switch (serverData.currentResponse.name) {
                // case 'feature_enter':
                //     nextStateName = 'feature.enter';
                //     break;
                // case 'respin':
                case 'bonus1_respin':
                case 'bonus2_respin':
                    nextStateName = 'respin';
                    break;
                case 'max_win_reached':
                    nextStateName = 'max.win';
                    break;
            }

            break;

        case "feature.round.completed":
            // hasMaxWin = serverData.nextResponses.length === 2 && (serverData.nextResponses[0].etn === 'max_win_reached');
            // const bonus1_counter = serverData.featureCount['bonus_1'] || 0;
            // const bonus2_counter = serverData.featureCount['bonus_2'] || 0;
            // if (bonus1_counter <= 0 && bonus2_counter <= 0) {
            //     nextStateName = "feature.exit";
            // }
            // if (bonus1_counter > 0 || bonus2_counter > 0) {
            //     nextStateName = "feature.spin.start";
            // }
            // if (hasMaxWin) {
            //     nextStateName = "feature.exit";
            // }
            nextStateName = "feature.spin.start";
            switch (serverData.currentResponse.name) {
                case 'feature_exit':
                    nextStateName = 'feature.exit';
                    break;
                // case 'max_win_reached':
                //     nextStateName = 'max.win';
                //     break;
            }

            break;

        case 'respin':
            nextStateName = 'spin.stop';

            if (serverData.currentResponse.name.includes("bonus")) {
                nextStateName = 'feature.spin.stop';
            }

            break;

        case 'max.win':
            nextStateName = 'round.completed';

            switch (serverData.currentResponse.name) {
                case 'feature_exit':
                    nextStateName = 'feature.round.completed';
                    break;
            }

            break;
    }

    return nextStateName;
};